import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175c0da4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 verify-card" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 mb-5" }
const _hoisted_4 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_5 = { class: "col-lg-6 mb-5" }
const _hoisted_6 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  key: 0,
  class: "col-lg-6 mb-5"
}
const _hoisted_9 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_10 = { class: "col-lg-6 mb-5" }
const _hoisted_11 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = {
  class: "btn btn-outline btn-outline-default px-3 py-2 d-flex align-items-center",
  for: "verification_gender_male_tenant"
}
const _hoisted_15 = { class: "d-block fw-semobold text-start" }
const _hoisted_16 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = {
  class: "btn btn-outline btn-outline-default px-3 py-2 d-flex align-items-center",
  for: "verification_gender_female_tenant"
}
const _hoisted_19 = { class: "d-block fw-semobold text-start" }
const _hoisted_20 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_21 = { class: "col-lg-6 mb-5" }
const _hoisted_22 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_23 = { class: "col-lg-6 mb-5" }
const _hoisted_24 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_25 = {
  key: 0,
  class: "col-lg-6 mb-5"
}
const _hoisted_26 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_27 = { class: "col-lg-12 mb-5" }
const _hoisted_28 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-4 mb-3" }
const _hoisted_31 = { class: "col-lg-8" }
const _hoisted_32 = { class: "col-lg-12 mb-5" }
const _hoisted_33 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_34 = { class: "col-lg-12 mb-5" }
const _hoisted_35 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_36 = { class: "form-label fs-6 fw-bold text-dark required mt-3" }
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = {
  key: 0,
  class: "socialMediaCard"
}
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, "Account ID:", -1))
const _hoisted_41 = { class: "text-center mt-3" }
const _hoisted_42 = { class: "text-center mt-7" }

import { ref, watch } from "vue";
import { Field } from "vee-validate";
import CopyButton from "@/components/CopyButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfos',
  props: {
    verificationDetails: {}
  },
  setup(__props: any) {

const props = __props;



const item = ref<any>({
  ...props.verificationDetails?.info,
});

watch(
  () => props.verificationDetails,
  () => {
    item.value = {
      ...props.verificationDetails?.info,
    };
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("fields.firstName")), 1),
        _createVNode(_component_el_input, {
          modelValue: item.value.firstName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.firstName) = $event)),
          name: "firstName",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("fields.lastName")), 1),
        _createVNode(_component_el_input, {
          modelValue: item.value.lastName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.lastName) = $event)),
          name: "lastName",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (item.value.nativeName !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("fields.nativeName")), 1),
              _createVNode(_component_el_input, {
                modelValue: item.value.nativeName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.nativeName) = $event)),
                name: "nativeName",
                size: "large"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("fields.gender")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "0",
                class: "btn-check",
                name: "gender",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.gender) = $event)),
                id: "verification_gender_male_tenant"
              }, null, 512), [
                [_vModelRadio, item.value.gender]
              ]),
              _createElementVNode("label", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("fields.male")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "1",
                class: "btn-check",
                name: "gender",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.gender) = $event)),
                id: "verification_gender_female_tenant"
              }, null, 512), [
                [_vModelRadio, item.value.gender]
              ]),
              _createElementVNode("label", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("fields.female")), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("fields.birthdate")), 1),
        _createVNode(_component_el_date_picker, {
          modelValue: item.value.birthdate,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.birthdate) = $event)),
          type: "date",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("fields.citizen")), 1),
        _createVNode(_component_el_input, {
          modelValue: item.value.citizen,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((item.value.citizen) = $event)),
          name: "citizen",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      (item.value.residence)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("fields.residence")), 1),
            _createVNode(_component_el_input, {
              modelValue: item.value.residence,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((item.value.residence) = $event)),
              name: "residence",
              size: "large"
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("fields.phone")), 1),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_input, {
              size: "large",
              modelValue: item.value.ccc,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((item.value.ccc) = $event)),
              name: "ccc"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_el_input, {
              modelValue: item.value.phone,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((item.value.phone) = $event)),
              name: "phone",
              size: "large"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("fields.email")), 1),
        _createVNode(_component_el_input, {
          modelValue: item.value.email,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((item.value.email) = $event)),
          name: "email",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("fields.address")), 1),
        _createVNode(_component_el_input, {
          modelValue: item.value.address,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((item.value.address) = $event)),
          name: "address",
          size: "large"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("title.socialMedia")), 1),
    _createElementVNode("div", _hoisted_37, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.socialMedium, (type, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (type.account != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.$t("fields." + type.name)), 1),
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, _toDisplayString(type.account), 1),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(CopyButton, {
                    content: type.account
                  }, null, 8, ["content"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})